// Pantalla de retorno tras el pago en Stripe. IKOGNIT abre el Checkout en una
// PESTAÑA APARTE (la principal sigue viva y completa la compra sola). Stripe
// redirige aquí (`/?paid=1` éxito, `/?paid=cancel`); mostramos un mensaje breve
// e intentamos cerrar la pestaña — la activación real ocurre en la principal.
import { useEffect } from 'react';
import { t } from './i18n';

export default function PaidReturn(): JSX.Element {
  const ok = new URLSearchParams(window.location.search).get('paid') === '1';
  useEffect(() => {
    // La abrió window.open desde la app → el script puede cerrarla. Si el
    // navegador lo impide, queda el mensaje y el botón manual.
    const id = setTimeout(() => { try { window.close(); } catch { /* */ } }, ok ? 1400 : 500);
    return () => clearTimeout(id);
  }, [ok]);
  return (
    <div className="pay-return">
      <div className="pay-return-card">
        <div className={'pay-return-ico ' + (ok ? 'ok' : 'cancel')} aria-hidden="true">{ok ? '✓' : '✕'}</div>
        <h1>{ok ? t('pay.return.okTitle') : t('pay.return.cancelTitle')}</h1>
        <p>{ok ? t('pay.return.okBody') : t('pay.return.cancelBody')}</p>
        <button type="button" className="primary" onClick={() => { try { window.close(); } catch { /* */ } }}>
          {t('pay.return.close')}
        </button>
      </div>
    </div>
  );
}
